import { IdMap } from 'components/Visualization/PixiGraph/core/IdMap';

import { AGraphNode } from './Node';
import { AGraphNodeId } from './types';

export class NodeIdMap extends IdMap<AGraphNodeId, AGraphNode> {}
